import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/empty';
import { AppointmentModel } from '../model/index';

@Injectable()
export class AppointmentService {
    private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'q=0.8;application/json;q=0.9' });
    private clientWalkUrl = 'api/appointment';  // URL to web api

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    getAppointmentList(query: any): Promise<AppointmentModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.clientWalkUrl}/getAppointmentList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    changeAppointmentUser(haData: any): Promise<AppointmentModel> {
        const url = `${this.clientWalkUrl}/changeAppointmentUser`;
        return this.http
            .post(url, $.param(haData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as AppointmentModel)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<AppointmentModel> {
        //console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}


// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/appointment.service.ts